<template>
    <div>
        <template v-if="condaUseV2FrontendPortfolioDashboard">
            <PortfolioDashboard />
        </template>
        <template v-else>
            <AccountLegalOverviewCompanyData @edit="navigateTo('Company Data')" />
            <AccountLegalOverviewAddressData @edit="navigateTo('Address Data')" />
            <AccountLegalOverviewBankData @edit="navigateTo('Bank Data')" />
            <AccountLegalOverviewTaxData @edit="navigateTo('Tax Data')" />
        </template>
    </div>
</template>
<script setup lang="ts">
import { ref, watchEffect } from 'vue'
import PortfolioDashboard from '../portfolio/PortfolioDashboard.vue'
import { navigateTo } from '../../../utilities/account/useAccountNavigationLegal'
import AccountLegalOverviewCompanyData from './overview/AccountLegalOverviewCompanyData.vue'
import AccountLegalOverviewAddressData from './overview/AccountLegalOverviewAddressData.vue'
import AccountLegalOverviewBankData from './overview/AccountLegalOverviewBankData.vue'
import AccountLegalOverviewTaxData from './overview/AccountLegalOverviewTaxData.vue'

const condaUseV2FrontendPortfolioDashboard = ref<number>(0)

watchEffect(() => {
    condaUseV2FrontendPortfolioDashboard.value = window.condaUseV2FrontendPortfolioDashboard
})
</script>

<style scoped></style>
